import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCompanyNewFinTagsValue,
  UniversalFilterCompanyNewFinTagsModes,
  UniversalFilterCompanyNewFinTagsOnChange
} from './UniversalFilterCompanyNewFinTags.types';

import { useUniversalFilterCompanyNewFinTags } from './hooks/useUniversalFilterCompanyNewFinTags';

import { TeamNewFinStatusReasonTagsMultiSelect } from '../../../../../main/teams/helpers/TeamNewFinStatusReasonTagsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterCompanyNewFinTagsProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCompanyNewFinTagsValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterCompanyNewFinTagsOnChange;
}

function UniversalFilterCompanyNewFinTags({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterCompanyNewFinTagsProps) {
  const { modeOptions, filterState, handleModeChange, handleTagIdsChange } =
    useUniversalFilterCompanyNewFinTags({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterCompanyNewFinTagsModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <TeamNewFinStatusReasonTagsMultiSelect
        key={filterState.mode}
        value={filterState.tagIds || []}
        autoFocus={autoFocus}
        onChange={handleTagIdsChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCompanyNewFinTags;
